import { BasicButton, Stack } from "@certn/cascadia";
import { Card, List, ListItem, mq, Text, Link } from "@certn/cascadia-react";
import { css } from "@emotion/css";
import { useTranslation, Trans } from "react-i18next";
import { useNavigate } from "react-router-dom";

export function PlatformCards() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  return (
    <div className={styles.platformCardsContainer}>
      <Card
        border="dropshadow"
        className={styles.card}
        background="background-success-weak"
        padding="space-4"
      >
        <Text style="global/title-small" color="brand-certn-moss">
          {t("Certn Legacy")}
        </Text>
        <Stack>
          <img
            src="/images/certnlegacy.png"
            alt="Certn Legacy"
            className={styles.image}
          />
          <Stack gap="space-2">
            <Text style="form/body-primary" color="text-weak">
              {t("For clients using our original Platform. Use this if:")}
            </Text>
            <List type="unordered">
              <ListItem color="text-weak">
                <Trans
                  i18nKey="You signed up before <bold>March 2025</bold> or haven’t been notified about switching to CertnCentric"
                  components={{ bold: <strong /> }}
                />
              </ListItem>
              <ListItem color="text-weak">
                <Trans>You first created an account on</Trans>{" "}
                <Link
                  textColor="text-weak"
                  href="https://certnlime.ca"
                  isNewTab
                  testID="certnlime-ca-link"
                >
                  certnlime.ca
                </Link>{" "}
                <Trans>or</Trans>{" "}
                <Link
                  textColor="text-weak"
                  href="https://certnlime.com"
                  isNewTab
                  testID="certnlime-com-link"
                >
                  certnlime.com
                </Link>
                <Trans>, or have previously used</Trans>{" "}
                <Link
                  textColor="text-weak"
                  href="https://lime.certn.co"
                  isNewTab
                  testID="lime-certn-co-link"
                >
                  lime.certn.co
                </Link>{" "}
                <Trans>to log into your account.</Trans>
              </ListItem>
            </List>
          </Stack>
        </Stack>
        <BasicButton
          fullWidth
          onPress={() => (window.location.href = "https://app.certn.co/login")}
        >
          {t("Log in to Legacy Platform")}
        </BasicButton>
      </Card>
      <Card
        border="dropshadow"
        className={styles.card}
        background="background-success-weak"
        padding="space-4"
      >
        <Stack gap="space-4">
          <Text style="global/title-small" color="brand-certn-moss">
            {t("CertnCentric")}
          </Text>
          <Stack>
            <img
              src="/images/certncentric.png"
              alt="CertnCentric"
              className={styles.image}
            />
            <Stack gap="space-2">
              <Text style="form/body-primary" color="text-weak">
                {t(
                  "Our new and improved screening platform. Available to clients who:"
                )}
              </Text>
              <List type="unordered">
                <ListItem color="text-weak">
                  <Trans
                    i18nKey="Created an account online after <bold>March 2025</bold>, or"
                    components={{ bold: <strong /> }}
                  />
                </ListItem>
                <ListItem color="text-weak">
                  {t("Received a direct upgrade notification from Certn")}
                </ListItem>
              </List>
            </Stack>
          </Stack>
        </Stack>
        <BasicButton fullWidth onPress={() => navigate("/")}>
          {t("Log in to CertnCentric")}
        </BasicButton>
      </Card>
    </div>
  );
}

const styles = {
  platformCardsContainer: css(
    {
      display: "flex",
      width: "90%",
      backgroundColor: "var(--surface-base)",
      gap: "var(--space-6)",
      alignItems: "start",
    },
    mq({
      flexDirection: ["column", "column", "row"],
    })
  ),
  card: css({
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
    gap: "var(--space-4)",
    alignSelf: "stretch",
    borderRadius: "var(--border-radius-4)",
  }),
  image: css({
    border: "1px solid var(--border-base)",
    borderRadius: "var(--border-radius-4)",
  }),
};
